module.exports = __webpack_public_path__ + "static/media/thoriacImage3.94091ebc.png";